import { Injectable, Inject, OpaqueToken, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class ConfigService {
    private config: any = {};
    
    constructor(private http: Http) {}
    
    load(): Observable<ConfigService> {
        // load config from the current directory
        return this.http.get("./obpa-config.json")
            .map(response => this.use(response.json()))
            .catch(() => Observable.throw("Unable to retrieve configuration."));
    }

    use(configObject: any): ConfigService {
        this.config = configObject;
        return this;
    }
    
    get(key: string): any {
        return this.getProperty(key);
    }

    getString(key: string): string | undefined {
        let val = this.getProperty(key);
        return ((typeof val === "string") ? val : undefined);
    }

    getStringOrDefault(key: string, def: string): string {
        let val = this.getString(key);
        return ((val !== undefined) ? val : def);
    }

    getBoolean(key: string): boolean | undefined {
        let val = this.getProperty(key);
        return ((typeof val === "boolean") ? val : undefined);
    }

    getBooleanOrDefault(key: string, def: boolean): boolean {
        let val = this.getBoolean(key);
        return ((val !== undefined) ? val : def);
    }

    getNumber(key: string): number | undefined {
        let val = this.getProperty(key);
        return ((typeof val === "number") ? val : undefined);
    }

    getNumberOrDefault(key: string, def: number): number {
        let val = this.getNumber(key);
        return ((val !== undefined) ? val : def);
    }
    
    private getProperty(key: string): any {
        let splitKey = key.split(".");

        return splitKey.reduce((prev: any, curr: string) => {
            return prev ? prev[curr] : undefined;
        }, this.config);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/config.service.ts